import { NominationIdRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getPreviewNextNomination: (
  fetchContext: FetchContext,
  awardId: number,
  userId: number,
  viewedNominationId?: number,
  countryId?: number,
  accessToken?: string,
) => Promise<NominationIdRef> = (fetchContext, awardId, userId, viewedNominationId, countryId, accessToken) => {
  const searchParams = new URLSearchParams();

  if (viewedNominationId !== undefined) {
    searchParams.append('viewedNominationId', viewedNominationId.toString());
  }

  if (countryId !== undefined) {
    searchParams.append('countryId', countryId.toString());
  }

  const url = `${fetchContext.baseUrl}/api/staff/awards/${awardId}/judges/${userId}/preview-next-nomination${
    searchParams.size > 0 ? `?${searchParams}` : ''
  }`;

  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<NominationIdRef>(fetchContext.errorStore, response, 'get preview next nomination'))};
